/**
 * Search bar with search input and button to open filter screen
 */

import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDebounce } from 'use-debounce';
import { useI18n } from '../../../data/hooks/i18nHooks';
import styles from './SearchBar3.module.scss';
import { useLocation } from 'react-router-dom';
import ClearIcon from './xmark-solid-full.svg';

const SearchBar = (props) => {
    const {
            className,
            value,
            disableFilterButton = true,
            showEditIcon = false,
            children,
            favorites = false,
            onFilterClick,
            onTextChange,
            onToggleFavorites,
            showFavoritesButton = true,
            showClearButton = false,
            autoFocus = false,
        } = props,
        i18n = useI18n(),
        [text, setText] = useState(value),
        [debouncedText] = useDebounce(text, 750),
        { hash } = useLocation(),
        ref = useRef();

    const handleInputChange = useCallback((e) => setText(e.target.value), []);

    const handleClearFilter = useCallback(() => {
        setText('');
        ref.current.focus();
    }, []);

    useEffect(() => setText(value), [value]);

    useEffect(() => {
        if (onTextChange) onTextChange(debouncedText);
    }, [debouncedText, onTextChange]);

    // focus on the search input if the location hash contains #openSearch
    useEffect(() => {
        const hashContents = hash.split(/\W/);
        if (hashContents.includes('openSearch')) {
            document.querySelector('input[name="search"]').focus();
        }
    }, []);

    // autofocus when the search appears the first time
    useEffect(() => {
        if (autoFocus) {
            document.querySelector('input[name="search"]').focus();
        }
    }, []);

    const handleFocus = useCallback((e) => {
        e.target.select();
    }, []);

    return (
        <div className={styles.searchBarWrapper}>
            <div className={[styles.SearchBar, className].join(' ')}>
                <input ref={ref} type="text" placeholder={i18n['label.search']} name="search" value={text} onChange={handleInputChange} onFocus={handleFocus} />
                {showClearButton ? (
                    <button type="button" className={styles.clear} onClick={handleClearFilter}>
                        <ClearIcon />
                    </button>
                ) : null}
                {!disableFilterButton ? <button type="button" className={[styles.showFilter, showEditIcon ? 'icon edit' : '', 'clickable'].join(' ')} onClick={onFilterClick}></button> : null}
                {showFavoritesButton && onToggleFavorites ? (
                    <button type="button" className={[styles.favorites, favorites ? styles.enabled : styles.disabled, 'clickable'].join(' ')} onClick={onToggleFavorites} />
                ) : null}
            </div>
            {children}
        </div>
    );
};

export default SearchBar;
